module.exports = __webpack_public_path__ + "img/img12.050b9943.png";